// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gW2Ln","title":"styles_title__PXKaN","description":"styles_description__9mi19"};